class Extension {
  constructor(sipExtension, cityId) {
    this.sipExtension = sipExtension;
    this.cityId = cityId;
  }
}
export default {
  inject: ['load'],
  data() {
    return {
      confimType: '',
      extensionId: null,
      searchTitle: '',
      disabelConfirm: false,
      addFlag: false,
      modalTitle: '',
      showAddEditModal: false,
      modalIcon: '',
      extensionManagmentInformationTableHeaders: [
        { text: 'ردیف', value: 'counter', align: 'center' },
        { text: 'شهرستان', value: 'city', align: 'center' },
        { text: 'داخلی', value: 'sipExtension', align: 'center' },
        { text: 'عملیات', value: 'actions', sortable: false, align: 'center' },
      ],
    };
  },
  methods: {
    enableAddEditFunction: function (type, id) {
      if (type == 1) {
        this.modalTitle = 'افزودن داخلی';
        this.modalIcon = 'mdi-plus';
        this.addFlag = true;
        this.confimType = 'add';
        this.showAddEditModal = true;
      } else if (type == 2) {
        this.modalTitle = 'ویرایش داخلی';
        this.modalIcon = 'mdi-pencil';
        this.confimType = 'edit';
        this.addFlag = false;
        this.getExtensionFunction(id);
        this.showAddEditModal = true;
      }
    },
    cancelAddEditFunction: function () {
      this.extension = new Extension('', null);
      this.showAddEditModal = false;
    },
    showConfirmDialogFunction: function () {
      if (this.confimType == 'add') {
        this.addExtensionFunction();
      } else if (this.confimType == 'edit') {
        this.$refs.confirm.title = 'ویرایش داخلی';
        this.$refs.confirm.text = 'از ویرایش داخلی اطمینان دارید؟';
        this.$refs.confirm.showConfirmDialog = true;
      } else if (this.confimType == 'delete') {
        this.$refs.confirm.title = 'حذف داخلی';
        this.$refs.confirm.text = 'از حذف داخلی اطمینان دارید؟';
        this.$refs.confirm.showConfirmDialog = true;
      }
      requestAnimationFrame(() => {
        if (this.$refs.yes) {
          this.$refs.yes.$el.focus();
        }
      });
    },
    confirmDialogConfirmFunction: function () {
      if (this.confimType == 'add') {
        this.disabelConfirm = true;
        this.addExtensionFunction();
      } else if (this.confimType == 'edit') {
        this.disabelConfirm = true;
        this.editExtensionFunction();
      } else if (this.confimType == 'delete') {
        this.disabelConfirm = true;
        this.deleteExtensionFunction();
      }
    },
    confirmDialogCancelFunction: function () {
      if (this.confimType == 'add') {
        this.$refs.confirm.showConfirmDialog = false;
        this.disabelConfirm = false;
      } else if (this.confimType == 'edit') {
        this.$refs.confirm.showConfirmDialog = false;
        this.disabelConfirm = false;
      } else if (this.confimType == 'delete') {
        this.$refs.confirm.showConfirmDialog = false;
        this.disabelConfirm = false;
      }
    },
    //delete
    showDeleteConfirmFunction: function (id) {
      this.extensionId = id;
      this.confimType = 'delete';
      this.showConfirmDialogFunction();
    },
  },
};
